import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ServicesOverview() {
  return <section data-section-id="19333" id="caregiver-corner-hero" className="relative min-h-screen w-full overflow-hidden bg-background bg-gradient-to-b from-secondary to-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-white/40 z-10" /> {}
        <div className="h-full w-full bg-cover bg-center bg-fixed bg-no-repeat opacity-60 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570824/img/diverse_caregivers_healing_embrace.png)]" />
      </div>

      {}
      <div className="absolute inset-0 z-10 pointer-events-none opacity-10" style={{
      backgroundImage: `
            linear-gradient(to right, rgba(0, 0, 0, 0.05) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(0, 0, 0, 0.05) 1px, transparent 1px)
          `,
      backgroundSize: "40px 40px"
    }} />

      {}
      <div className="absolute inset-0 z-10 pointer-events-none mix-blend-multiply">
        <div className="absolute top-0 left-1/4 h-[500px] w-[500px] -translate-y-1/2 rounded-full bg-chart-2/20 blur-[60px]" />
        <div className="absolute bottom-0 right-1/4 h-[600px] w-[600px] translate-y-1/3 rounded-full bg-chart-2/15 blur-[80px]" />
      </div>

      {}
      <div className="relative z-20 flex min-h-screen flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div className="max-w-5xl space-y-8">
          {}
          <h1 className="font-serif text-5xl font-black tracking-tight text-primary sm:text-6xl md:text-7xl lg:text-[84px] lg:leading-[1.1]">
            Compassionate Support <br className="hidden md:block" />
            for Every Caregiver
          </h1>

          {}
          <p className="mx-auto max-w-2xl font-sans text-lg font-normal leading-relaxed tracking-normal text-muted-foreground sm:text-xl md:text-2xl">
            A sanctuary of stories, resources, and shared experiences designed to uplift those who care for our littlest warriors.
          </p>

          <p className="mx-auto max-w-2xl font-sans text-lg font-normal leading-relaxed text-muted-foreground sm:text-xl">
            We also host a Monthly Virtual Caregiver Support Group—a safe, moderated space to connect with others who truly understand your journey.
          </p>

          <ul className="mx-auto max-w-lg space-y-4 text-left font-sans text-muted-foreground">
            {["Shared emotional support and validation from peers", "Practical tips for navigating complex medical challenges", "Expert-led discussions on resilience and self-care", "A compassionate community that celebrates every victory"].map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                <div className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-chart-2 shadow-[0_0_10px_rgba(218,165,32,0.3)]" />
                <span className="text-base sm:text-lg">{benefit}</span>
              </li>)}
          </ul>

          {}
          <div className="pt-8">
            <Button asChild size="lg" className="group relative overflow-hidden border-none bg-chart-2 px-8 py-6 text-lg font-bold text-primary-foreground rounded-full shadow-[0_0_20px_rgba(218,165,32,0.3)] transition-all hover:scale-105 hover:bg-chart-2/90 hover:shadow-[0_0_40px_rgba(218,165,32,0.5)]">
              <Link to="/CaregiverCornerPage">
                <span className="relative z-10 flex items-center gap-2">
                  FIND YOUR COMMUNITY
                  <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
                </span>
                {}
                <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <style dangerouslySetInnerHTML={{
      __html: `
          @keyframes shimmer {
            100% {
              transform: translateX(100%);
            }
          }
        `
    }} />
    </section>;
}